import { useProjectDetails } from 'domain/projects/newProject/dashboard/hooks/useProjectDashboard';
import { ExternalResource } from 'domain/shared/newProject';

const useProjectToolsInputData = (projectId: string, relatedProjectId?: string) => {
  const { project, isDataReloading: isProjectLoading } = useProjectDetails(projectId);
  const { project: relatedProject, isDataReloading: isRelatedProjectLoading } = useProjectDetails(relatedProjectId);

  const findExternalResource = (resources: ExternalResource[] | undefined, name: string) => {
    return resources?.find(resource => resource.name === name)?.value;
  };

  const getData = () => {
    if (!project || (relatedProjectId && !relatedProject)) {
      return {};
    }

    const externalResourcesRelatedProject = relatedProject?.resourcesData?.externalResources;
    const initialProjectName = project?.budget?.sowId ? `${project?.budget?.sowId} ${project?.name}` : project?.name;
    const initialAccountId = project?.accountData?.accountId?.toString();
    const initialAccountName = project?.accountData?.accountName;

    return {
      davinciProjectId: project?.id,
      name: initialProjectName,
      identifier: project?.name?.replaceAll(/\s+/g, '-').toLowerCase(),

      parentIdentifier: initialAccountId?.toLowerCase(),
      parentName: initialAccountName,
      parentNameExists: !!initialAccountName,

      isNeedToCreateTeamsGroup: false,
      teamsProjectCodeName: initialProjectName,
      existedTeamsWebUrl: findExternalResource(externalResourcesRelatedProject, 'teamsWebUrl'),

      isNeedToCreateGitlabGroup: false,
      gitlabGroupProjectCodeName: initialProjectName,
      gitlabGroupAccountAlias: initialAccountId,
      gitlabGroupAccountName: initialAccountId ? `${initialAccountId} - ${initialAccountName}` : null,
      existedGitlabWebUrl: findExternalResource(externalResourcesRelatedProject, 'gitlabWebUrl'),

      isNeedToCreateSharepoint: false,
      sharepointProjectCodeName: initialProjectName,
      existedSharepointWebUrl: findExternalResource(externalResourcesRelatedProject, 'sharepointWebUrl'),

      isNeedToCreateOnePassword: (project?.sensitiveData?.onePasswordVaults || []).length === 0,
      onePasswordVaults: relatedProject?.sensitiveData?.onePasswordVaults || [],
      azureGroups: relatedProject?.sensitiveData?.azureGroups || [],
    };
  };

  return {
    isLoading: isProjectLoading || (relatedProjectId && isRelatedProjectLoading),
    data: getData(),
  };
};

export default useProjectToolsInputData;
